import '../jquery'

function legacy_domain_migration() {

  var $checked, setChecked, setUnchecked;

  $checked = false;
  $('#email_migrations_check_all').on('click', function (event) {
    var cbxs;
    cbxs = $('#email_migrations_table').find('input[type="checkbox"]');
    cbxs.prop('checked', $checked = !$checked);
    if ($checked) {
      setChecked();
    } else {
      setUnchecked();
    }
  });

  $('.email_migrations-select-all').on('click', function (event) {
    var cbxs;
    event.preventDefault();
    cbxs = $('#email_migrations_table').find('input[type="checkbox"]');
    cbxs.prop('checked', true);
    setChecked();
  });

  $('.email_migrations-select-none').on('click', function (event) {
    var cbxs;
    event.preventDefault();
    cbxs = $('#email_migrations_table').find('input[type="checkbox"]');
    cbxs.prop('checked', false);
    setUnchecked();
  });

  setChecked = function () {
    $('#email_migrations_check_all').find('i').removeClass('fa-square').removeClass('fa-minus-square').removeClass('fa-check-square').removeClass('text-muted').addClass('fa-check-square');
    $checked = true;
  };

  setUnchecked = function () {
    $('#email_migrations_check_all').find('i').removeClass('fa-square').removeClass('fa-minus-square').removeClass('fa-check-square').removeClass('text-muted').addClass('fa-square text-muted');
    $checked = false;
  };

  $('.email_migration-batch-action').on('click', function (event) {
    event.preventDefault();
    $.ajax({
      type: 'POST',
      url: $(this).data('url'),
      dataType: 'json',
      data: {
        email_migration_ids: $('input.email_migrations_email_migration[type="checkbox"]:checked').map(function () {
          return $(this).data('id');
        }).get()
      },
      success: function (data) {
        window.location = data.url;
      },
      error: function (jqXHR, textStatus) {
        console.log('params', jqXHR);
        window.alert('Request failed: ' + textStatus + ' ' + jqXHR.responseText);
      }
    });
  });

}


$(document).ready(legacy_domain_migration);
$(document).on("turbo:load", legacy_domain_migration);
